export default {
  connectedChannelHeader: {
    channelBanner: 'dt.channel.connectedChannelHeader.channelBanner',
    channelAvatar: 'dt.channel.connectedChannelHeader.channelAvatar',
    copyLinkButton: 'dt.channel.connectedChannelHeader.copyLinkButton',
    editButton: 'dt.channel.connectedChannelHeader.editButton',
    channelEntriesCount: 'dt.channel.connectedChannelHeader.channelEntriesCount',
    followersButton: 'dt.channel.connectedChannelHeader.followersButton',
    channelFollowersCount: 'dt.channel.connectedChannelHeader.channelFollowersCount',
    channelFollowingCount: 'dt.channel.connectedChannelHeader.channelFollowingCount',
    followingButton: 'dt.channel.connectedChannelHeader.followingButton',
    createdTab: 'dt.channel.connectedChannelHeader.createdTab',
    enteredTab: 'dt.channel.connectedChannelHeader.enteredTab',
    allButton: 'dt.channel.connectedChannelHeader.allButton',
    upcomingButton: 'dt.channel.connectedChannelHeader.upcomingButton',
    contestStatusBar: 'dt.channel.connectedChannelHeader.contestStatusBar',
    liveButton: 'dt.channel.connectedChannelHeader.liveButton',
    recentButton: 'dt.channel.connectedChannelHeader.recentButton',
    channelName: 'dt.channel.connectedChannelHeader.channelName',
    channelHandle: 'dt.channel.connectedChannelHeader.channelHandle',
    channelDescription: 'dt.channel.connectedChannelHeader.channelDescription',
    followButton: 'dt.channel.connectedChannelHeader.followButton',
  },
  channelContests: {
    channelContestsEmptyState: 'dt.channel.channelContests.channelContestsEmptyState',
  },
  search: {
    followingTab: 'dt.channel.search.followingTab',
    followersTab: 'dt.channel.search.followersTab',
    searchInputfield: 'dt.channel.search.searchInputfield',
    emptyState: 'dt.channel.search.emptyState',
    followersEmptyState: 'dt.channel.search.tyState',
    searchResult: 'dt.channel.search.searchResult',
  },
  channelDetailPage: {
    createaContestButton: 'dt.channel.channelDetailPage.createaContestButton',
  },
  channelErrorScreen: 'dt.channel.channelErrorScreen',
  channelEditPage: {
    nameInput: 'dt.channel.channelEditPage.nameInput',
    handleInput: 'dt.channel.channelEditPage.handleInput',
    descriptionInput: 'dt.channel.channelEditPage.description',
    saveChangesButton: 'dt.channel.channelEditPage.saveChangesButton',
  },
  invitesManager: {
    clearButton: 'dt.channel.invitesManager.clearButton',
    connectedInviteEmails: 'dt.channel.invitesManager.connectedInviteEmails',
    connectedInvitesData: 'dt.channel.invitesManager.connectedInvitesData',
    emailEmptyState: 'dt.channel.invitesManager.emailEmptyState',
    emptyState: 'dt.channel.invitesManager.emptyState',
    followersEmptyState: 'dt.channel.invitesManager.followersEmptyState',
    followersTabCheckBox: 'dt.channel.invitesManager.followersTabCheckBox',
    groupsEmptyState: 'dt.channel.invitesManager.groupsEmptyState',
    IconChevronLeft: 'dt.channel.invitesManager.IconChevronLeft',
    inviteFollowers: 'dt.channel.invitesManager.inviteFollowers',
    InvitesManagerFollowersTab: 'dt.channel.invitesManager.InvitesManagerFollowersTab',
    invitesMangerTabs: 'dt.channel.invitesManager.invitesMangerTabs',
    invitesTableEmptyState: 'dt.channel.invitesManager.invitesTableEmptyState',
    reviewInvitesFollowersCell: 'dt.channel.invitesManager.reviewInvitesFollowersCell',
    selectAllCheckbox: 'dt.channel.invitesManager.selectAllCheckbox',
    sendInviteButton: 'dt.channel.invitesManager.sendInviteButton',
    tableCellRight: 'dt.channel.invitesManager.tableCellRight',
    tabsCheckBox: 'dt.channel.invitesManager.tabsCheckBox',
    textInputField: 'dt.channel.invitesManager.textInputField',
    trashIcon: 'dt.channel.invitesManager.trashIcon',
  },
};
